
import "./App.css";
import { RootPage } from "./components";

const App = () => {
  return <RootPage />;
};

export default App;
